/**
 * ============================================================================
 * SUPCRV GLOBAL ANIMATIONS CONTROLLER
 * ============================================================================
 */

var SUPCRV = SUPCRV || {};

SUPCRV.Animations = {

  // 1. CENTRAL INITIALIZER
  init: function() {
    
    // Safety Check: Wait for GSAP & ScrollTrigger
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn("GSAP not loaded yet. Retrying...");
      var self = this; 
      setTimeout(function() { self.init(); }, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // --- RUN ANIMATIONS ---
    // Make sure to use 'this.' to call them
    this.footerTopFade();
    this.footerBottomFade();
    this.headerFadeDown();
    this.heroContentFade();
    this.dualSectionFade();
    this.productCardsContainerFade();
    this.faqSectionFade();
    this.staircaseSectionFade();
    this.imgTextSectionFade();
    this.initSupcrvColAllGridAnimations();
    this.initSupcrvAbtOurStoryAnimation();
    this.initCommonFadeUpAbtImgTextAnimation();
    this.initSupcrv3TabsFaqsAnim();
    this.initSupcrvContactAnim();
    this.initSupcrvYxtBasedPageContentGroupsAnim();
  },


  // --------------------------------------------------------------------------
  // Animation 1: Footer Top (.js-footer-top)
  // --------------------------------------------------------------------------
  footerTopFade: function() {
    var $target = $('.js-footer-top');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init');

    // Animate
    gsap.from($target[0], {
      scrollTrigger: {
        trigger: $target[0],
        start: "top 90%",
        toggleActions: "play none none none"
      },
      y: 50,
      opacity: 0,
      duration: 1.2,
      ease: "power2.out",
      clearProps: "all"
    });
  },


  // --------------------------------------------------------------------------
  // Animation 2: Footer Bottom (.js-footer-bottom)
  // --------------------------------------------------------------------------
  footerBottomFade: function() {
    var $target = $('.js-footer-bottom');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init');

    // Animate
    gsap.from($target[0], {
      scrollTrigger: {
        trigger: $target[0],
        start: "top 95%", // Starts a bit later/lower
        toggleActions: "play"
      },
      y: 50,
      opacity: 0,
      duration: 1.2,
      ease: "power2.out",
      clearProps: "all"
    });
  },

  // --------------------------------------------------------------------------
  // Header Fade Down (.supcrv_header-component)
  // --------------------------------------------------------------------------
  headerFadeDown: function() {
    var $target = $('.supcrv_header-component');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init');

    // Animate immediately (No ScrollTrigger)
    gsap.from($target[0], {
      y: -50,             // Start 50px ABOVE
      opacity: 0,         // Fade in
      duration: 0.6,
      ease: "power2.out",
      clearProps: "all"
    });
  },

  // --------------------------------------------------------------------------
  // Hero Content Fade Up - On Load (.supcrv_hero_content)
  // --------------------------------------------------------------------------
  heroContentFade: function() {
    var $target = $('.supcrv_hero_content');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init');

    // Animate immediately (No ScrollTrigger)
    gsap.from($target[0], {
      y: 50,              // Start 50px LOWER (moves Up)
      opacity: 0,         // Fade In
      duration: 1.2,
      delay: 0.5,         // Wait 0.5s so the user sees it happen
      ease: "power2.out",
      clearProps: "all"
    });
  },


  // --------------------------------------------------------------------------
  // Product Cards around Container Fade Up
  // Target: .supcrv_product_cards_around_section .supcrv_around_grid
  // --------------------------------------------------------------------------
  productCardsContainerFade: function() {
    var $target = $('.supcrv_product_cards_around_section .supcrv_around_grid');

    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-fade-init')) return;
    
    $target.addClass('supcrv-fade-init');

    gsap.from($target[0], {
      scrollTrigger: {
        trigger: $target[0],
        start: "top 85%", // Starts slightly earlier so it's visible before pinning
        toggleActions: "play"
      },
      y: 50,
      opacity: 0,
      duration: 1.2,
      ease: "power3.out"
    });
  },

  // --------------------------------------------------------------------------
  // Dual Section Fade Up (.supcrv_part_one, .supcrv_part_two)
  // --------------------------------------------------------------------------
  dualSectionFade: function() {
    // Select both parts
    var $targets = $('.supcrv_part_one_content, .supcrv_part_two_grid');

    if ($targets.length === 0) return;

    $targets.each(function() {
      var $el = $(this);
      
      // Prevent double init
      if ($el.hasClass('supcrv-init')) return;
      $el.addClass('supcrv-init');

      gsap.from($el[0], {
        scrollTrigger: {
          trigger: $el[0],
          start: "top 80%",
          toggleActions: "play"
        },
        y: 60, 
        opacity: 0, 
        duration: 1.2,
        ease: "power3.out"
      });
    });
  },


  // --------------------------------------------------------------------------
  // FAQ Section Fade Up
  // Target: .supcrv_faq_section .supcrv_container
  // --------------------------------------------------------------------------
  faqSectionFade: function() {
    var $target = $('.supcrv_faq_section .supcrv_container');

    if ($target.length === 0) return;
    
    // Check if already initialized to prevent duplicates
    if ($target.hasClass('supcrv-anim-init')) return;
    $target.addClass('supcrv-anim-init');

    gsap.from($target[0], {
      scrollTrigger: {
        trigger: $target[0],
        start: "top 85%", // Animation starts when top of container enters 85% of viewport
        toggleActions: "play"
      },
      y: 50,          // Move 50px Up
      opacity: 0,     // Fade In
      duration: 1.2,
      ease: "power3.out"
    });
  },


  // --------------------------------------------------------------------------
  // Staircase Section Fade Up
  // Target: .supcrv_staircase_section .supcrv_container
  // --------------------------------------------------------------------------
  staircaseSectionFade: function() {
    var $target = $('.supcrv_staircase_section .supcrv_container');

    if ($target.length === 0) return;
    
    // Prevent duplicate initialization
    if ($target.hasClass('supcrv-anim-init')) return;
    $target.addClass('supcrv-anim-init');

    gsap.from($target[0], {
      scrollTrigger: {
        trigger: $target[0],
        start: "top 85%", // Starts when top of section enters 85% of viewport
        toggleActions: "play"
      },
      y: 50,          // Move 50px Up
      opacity: 0,     // Fade In
      duration: 1.2,
      ease: "power3.out"
    });
  },


  // --------------------------------------------------------------------------
  // Image Text Section Fade Up
  // Target: .supcrv_home_img_text .supcrv_it_grid
  // --------------------------------------------------------------------------
  imgTextSectionFade: function() {
    // Select the grid wrapper inside the section
    var $target = $('.supcrv_home_img_text .supcrv_it_grid');

    if ($target.length === 0) return;
    
    // Check if already initialized
    if ($target.hasClass('supcrv-anim-init')) return;
    $target.addClass('supcrv-anim-init');

    gsap.from($target[0], {
      scrollTrigger: {
        trigger: $target[0],
        start: "top 85%", // Animation starts when top of grid enters 85% of viewport
        toggleActions: "play"
      },
      y: 50,          // Move 50px Up
      opacity: 0,     // Fade In
      duration: 1.2,
      ease: "power3.out"
    });
  },

  /* ==========================================================================
     SUPCRV GRID FADE UP ANIMATION - COLLECTION ALL
     ========================================================================== */
  
  initSupcrvColAllGridAnimations: function() {
    var $target = $('.supcrv-grid-section');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init');

    // Animate immediately (No ScrollTrigger)
    gsap.from($target[0], {
      y: 50,              // Start 50px LOWER (moves Up)
      opacity: 0,         // Fade In
      duration: 1.2,
      delay: 0.5,         // Wait 0.5s so the user sees it happen
      ease: "power2.out",
      clearProps: "all"
    });
  },

/* ==========================================================================
     SUPCRV STORY FADE UP ANIMATION (Immediate Load)
     ========================================================================== */
  
  initSupcrvAbtOurStoryAnimation: function() {
    
    if (typeof gsap === 'undefined') return;

    var $target = $('.supcrv-abt-our-story .supcrv-story-container');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init');

    // Animate immediately (No ScrollTrigger)
    gsap.from($target[0], {
      y: 50,              // Start 50px LOWER (moves Up)
      opacity: 0,         // Fade In
      duration: 1.2,
      delay: 0.5,         // Wait 0.5s so the user sees it happen
      ease: "power2.out",
      clearProps: "all"
    });
  },


  /* ==========================================================================
     ABOUT US IMG-TEXT SECTIONS-COMMON GSAP FADE UP ON SCROLL (.suprcrv-abt-img-text)
     ========================================================================== */
  
  initCommonFadeUpAbtImgTextAnimation: function() {
    
    // 1. Check GSAP
    if (typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    // 2. Select ALL elements with this class
    var $targets = $('.suprcrv-abt-img-text .supcrv_it_grid');

    // 3. Loop through each one to animate them INDEPENDENTLY
    $targets.each(function() {
      var $el = $(this);

      // Avoid double initialization
      if ($el.hasClass('supcrv-init-scroll')) return;
      $el.addClass('supcrv-init-scroll');

      // 4. The Animation
      gsap.from($el[0], {
        scrollTrigger: {
          trigger: $el[0],
          start: "top 85%",       // Starts when top of element hits 80% of viewport
          toggleActions: "play" // Play on enter, reverse on leave (optional)
        },
        y: 50,                    // Start 50px lower
        opacity: 0,               // Fade in
        duration: 1.0,
        ease: "power2.out",
        clearProps: "all"
      });
    });
  },


  /* ==========================================================================
    THREE TABS FAQ SECTION FADE UP (On Page Load)
         ========================================================================== */
      initSupcrv3TabsFaqsAnim: function() {
        var $target = $('.supcrv-3tabs-faq-section .supcrv-container');

        // Safety Checks
        if ($target.length === 0) return;
        if ($target.hasClass('supcrv-init-tabs')) return; // Unique init class
        
        // Mark as initialized
        $target.addClass('supcrv-init-tabs');

        // Check GSAP
        if (typeof gsap !== 'undefined') {
          gsap.from($target[0], {
            y: 50,              // Start 50px lower
            opacity: 0,         // Start invisible
            duration: 1.0,      
            delay: 0.3,         // 0.3s delay
            ease: "power2.out",
            clearProps: "all"   // Clean up CSS after animation
          });
        }
      },



  /* ==========================================================================
    CONTACT SECTION FADE UP (On Page Load)
  ========================================================================== */
  initSupcrvContactAnim: function() {
    var $target = $('.supcrv-contact-section .supcrv-container');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init-contact')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init-contact');

    // Check GSAP
    if (typeof gsap !== 'undefined') {
      gsap.from($target[0], {
        y: 50,              // Start 50px lower
        opacity: 0,         // Start invisible
        duration: 1.0,      
        delay: 0.4,         // 0.4s delay so it flows after the header
        ease: "power2.out",
        clearProps: "all"   // Clean up CSS after animation
      });
    }
  },


  initSupcrvYxtBasedPageContentGroupsAnim: function() {
    var $target = $('.supcrv-content-groups-section .supcrv-container');

    // Safety Checks
    if ($target.length === 0) return;
    if ($target.hasClass('supcrv-init-anim')) return;
    
    // Mark as initialized
    $target.addClass('supcrv-init-anim');

    // Check GSAP
    if (typeof gsap !== 'undefined') {
      gsap.from($target[0], {
        y: 40,              // Start 40px lower
        opacity: 0,         // Start invisible
        duration: 0.8,      
        delay: 0.2,         // Quick start
        ease: "power2.out",
        clearProps: "all"
      });
    }
  },



};


/**
 * ============================================================================
 * EXECUTION & SHOPIFY EVENTS
 * ============================================================================
 */
$(document).ready(function() {
  SUPCRV.Animations.init();
});

// Re-run on Theme Editor Change
$(document).on('shopify:section:load', function() {
  SUPCRV.Animations.init();
});